<template>
  <div class="container">
    <v-button v-for="player in ['male', 'female']" :key="player"
      icon="arrow_up"
      label="Kiezen"
      @click="select(player)"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AudioPlayer from '@/AudioPlayer'
import Button from '@/components/Button'
import stories from '@/data/stories'
import { defer } from '@/utils'

export default {
  name: 'SelectPlayerView',
  components: {
    'v-button': Button
  },
  methods: {
    ...mapActions([
      'loadScene',
      'selectStory',
      'selectPlayer'
    ]),
    select (player) {
      this.track('select_player', {
        event_category: 'player',
        event_label: player
      })
      defer(100, () => {
        this.selectPlayer(player)
        const story = stories[1]
        this.selectStory(story.id)
        const data = { ...story, index: 0 }
        this.loadScene({ name: 'Hospital', data })
      })
    }
  },
  mounted () {
    defer(1000, () => {
      AudioPlayer
        .load('audio/characters/wouter/select.mp3')
        .play()
    })
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  max-width: 32rem;
  height: 100%;
  padding: 6rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  @include fade-in(400ms, 2s);
}
</style>
